export default function ($scope, $rootScope) {
    $scope.isParentActive = function(item){
        for(let i in item._children)
            if($rootScope.current_page === item._children[i])
                return true;

        return $rootScope.toggle_open === item;
    };
}


/** WEBPACK FOOTER **
 ** ./js/controllers/menu.js
 **/